export const getHealthClass = (knockouts) => {
    let healthType = "Personalized Health Class";
    if (knockouts) {
        knockouts.forEach((index, i) => {
            if (index) {
                switch (i) {
                    case 0:
                        healthType = 'PP';
                        break;
                    case 1:
                        healthType = 'P';
                        break;
                    case 2:
                        healthType = 'RP'
                        break;
                    case 3:
                        healthType = 'R'
                        break;
                    case 4:
                        healthType = 'RR'
                        break;
                    default:
                        healthType = 'Personalized Health Class'
                        break;
                }
            }
        })
    }
    return healthType;
}

export const getHealthClassName = (value) => {
        
    switch (value) {
      case 'PP':
        return 'Preferred Plus';
      case 'P':
        return 'Preferred';
      case 'RP':
        return 'Standard Plus';
      case 'R':
        return 'Standard'
      case 'RR':
        return 'Substandard';
      case 'Personalized Health Class':
        return 'Personalized Health Class';
      default:
        return '';
    }
}


// WEBPACK FOOTER //
// ./src/components/Helpers/Lists/HealthClass.js